import { RISK_LOWER_THRESHOLD, RISK_UPPER_THRESHOLD } from '@/constants/risks';

const HIGH_RISK = 1;
const AVERAGE_RISK = 2;
const LOW_RISK = 3;

const isAboveAverage = (risk: number, average: number) => risk > average * RISK_UPPER_THRESHOLD;
const isBelowAberage = (risk: number, average: number) => risk < average * RISK_LOWER_THRESHOLD;

export function sortCancerRisks(a: { risk: number; averageRisk: number }, b: { risk: number; averageRisk: number }) {
  const aRiskCategory = isAboveAverage(a.risk, a.averageRisk)
    ? HIGH_RISK
    : isBelowAberage(a.risk, a.averageRisk)
    ? LOW_RISK
    : AVERAGE_RISK;
  const bRiskCategory = isAboveAverage(b.risk, b.averageRisk)
    ? HIGH_RISK
    : isBelowAberage(b.risk, b.averageRisk)
    ? LOW_RISK
    : AVERAGE_RISK;

  if (aRiskCategory !== bRiskCategory) return aRiskCategory - bRiskCategory;

  return Math.abs(b.risk) - Math.abs(a.risk);
}
